import { render } from "./AppsPage.vue?vue&type=template&id=3d356630&scoped=true"
import script from "./AppsPage.vue?vue&type=script&lang=js"
export * from "./AppsPage.vue?vue&type=script&lang=js"

import "./AppsPage.vue?vue&type=style&index=0&id=3d356630&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d356630"]])

export default __exports__